import { AccessStatistics } from '@security/access-statistics/AccessStatistics';
import { DetectedApplications } from '@security/detected-applications';
import { getExport } from '@sonar-software/sonar-core';
import { Issues } from './Issues';
import { Notifications } from './Notifications';
import { SalesForceSummary } from './SalesForceSummary';
import { SystemOverview } from '@security/system-overview';
import { UptimeMonitorsDashboard } from '@security/uptime-monitors-dashboard';
import { useDownload } from '@hooks';
import { VerticalColumn } from '@ui/general/VerticalColumn';
import { VerticalColumnView } from '@ui/general/VerticalColumnView';
import { FULL_ROUTES, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
export const DashboardView = () => {
    const params = useParams();
    const navigate = useNavigate();
    const download = useDownload();
    const downloadRequest = useCallback(() => getExport({ exportId: Number(params.id) }), [params.id]);
    useEffect(() => {
        if (params.id) {
            download({
                errorMessage: NOTIFICATIONS_COPY.ERROR_DOWNLOAD_EXPORT,
                request: downloadRequest
            });
            navigate(FULL_ROUTES.DASHBOARD, { replace: true });
        }
    }, [download, downloadRequest, navigate, params.id]);
    return (React.createElement(VerticalColumnView, null,
        React.createElement(VerticalColumn, null,
            React.createElement(UptimeMonitorsDashboard, null),
            React.createElement(SystemOverview, null),
            React.createElement(DetectedApplications, null)),
        React.createElement(VerticalColumn, null,
            React.createElement(SalesForceSummary, null),
            React.createElement(Notifications, null),
            React.createElement(AccessStatistics, null),
            React.createElement(Issues, null))));
};
